// Config panel for the "api_webhook" trigger block
import React from 'react';
import {
  Box,
  TextField,
  Typography,
  InputAdornment,
  Alert
} from '@mui/material';

const ApiWebhookConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    onSummaryChange(updated.endpointPath ? `POST /${updated.endpointPath}` : 'Webhook');
  };

  const baseUrl = `${window.location.origin}/api/qbusAutomations/webhook/`;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Triggers this automation when an external system calls the webhook endpoint via HTTP POST.
      </Typography>

      <TextField
        size="small"
        label="Endpoint Path"
        value={config.endpointPath || ''}
        onChange={(e) => handleChange('endpointPath', e.target.value.replace(/[^a-zA-Z0-9_-]/g, ''))}
        required
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Typography variant="caption" color="text.secondary" noWrap>
                /api/qbusAutomations/webhook/
              </Typography>
            </InputAdornment>
          ),
        }}
        helperText="Only letters, numbers, dashes and underscores"
      />

      <Alert severity="info" sx={{ '& .MuiAlert-message': { fontSize: '0.75rem' } }}>
        <strong>Full URL:</strong><br />
        <code style={{ wordBreak: 'break-all', fontSize: '0.7rem' }}>
          {baseUrl}{config.endpointPath || '{endpoint}'}
        </code>
      </Alert>

      <TextField
        size="small"
        label="Secret Token (optional)"
        value={config.secretToken || ''}
        onChange={(e) => handleChange('secretToken', e.target.value)}
        helperText="If set, requests must include this in the Authorization header"
      />

      <Alert severity="success" variant="outlined" sx={{ py: 0.5, '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
        <strong>Extra path segments & query params are supported.</strong><br />
        Example: <code style={{ fontSize: '0.65rem' }}>POST /webhook/{config.endpointPath || 'my-hook'}/123?format=json</code><br />
        Use an <strong>Extract Parameters</strong> action block downstream to pull values like
        <code style={{ fontSize: '0.65rem' }}> locationId=123</code> or <code style={{ fontSize: '0.65rem' }}>format=json</code> into
        variables for the rest of the flow.
      </Alert>

      <Typography variant="caption" color="text.secondary">
        The webhook accepts POST requests with an optional JSON body.
        The full request (body, extra path segments, query params) is
        available as trigger data in downstream nodes.
      </Typography>
    </Box>
  );
};

export default ApiWebhookConfig;
